import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Typography,
  DialogActions,
} from '@material-ui/core';
import { Spacing } from 'components';
import useAuth from 'hooks/useAuth';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const PasswordResetDialog: React.SFC<Props> = (props) => {
  const { isOpen, onClose } = props;
  const { user } = useAuth();

  const renderBody = () => (
    <>
      <Grid item>
        <Typography variant="subtitle1">Check Your Email!</Typography>
        <br />
        <Typography variant="body2">
          An email with a link to reset your password has been sent to:
        </Typography>
        <br />
        <Typography variant="body2" style={{ textAlign: 'center' }}>
          <b>{user.email}</b>
        </Typography>
        <br />
        <Typography variant="body2">Follow the link to complete the update.</Typography>
      </Grid>
      <Spacing height="32px" />
    </>
  );

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      aria-labelledby="password-dialog-title"
    >
      <DialogTitle id="password-dialog-title">Update Login Credentials</DialogTitle>
      <DialogContent>{renderBody()}</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => onClose()}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordResetDialog;
